import type { FeedbackAnswerQuestionTranslate, OptionQuestionTranslate } from '@repo/types/questions/QuestionTranslate';

import { useEffect, useMemo } from 'react';
import { useForm } from 'react-hook-form';

import {
  QuestionMarkedCorrectToggleField,
  QuestionMarkedExplanationField,
  QuestionMarkedFormActions,
  QuestionMarkedPointsField,
  QuestionMarkedResponseCard,
  QuestionMarkedResponseContent,
  QuestionMarkedResponseHeader,
} from '@/components/features/quiz/question/question-marked/QuestionMarked';
import { Badge } from '@/components/ui/badge';
import { Form, FormField } from '@/components/ui/form';

import type { QuestionMarkedTranslateFormProps } from '.';

export function QuestionMarkedTranslateForm(questionMarkedTranslateFormProps: QuestionMarkedTranslateFormProps) {
  const { marked, content, maxPoints, isOpen, onClose, onSubmit: _onSubmit } = questionMarkedTranslateFormProps;

  const selectedOptions = useMemo<OptionQuestionTranslate[]>(() => content.options.filter((o) => (marked?.ids ?? []).includes(o.id)), [content, marked]);

  const form = useForm<FeedbackAnswerQuestionTranslate>({
    defaultValues: {
      points: 0,
      correct: false,
      explanation: null,
    },
  });

  const onSubmit = (data: FeedbackAnswerQuestionTranslate) => {
    onClose();
    _onSubmit?.(data);
  };

  useEffect(() => {
    if (isOpen && marked) {
      form.reset(marked);
    }
  }, [isOpen, marked]);
  return (
    <Form {...form}>
      <form className={'flex w-full flex-col gap-3 p-3'} onSubmit={form.handleSubmit(onSubmit)} noValidate>
        <QuestionMarkedResponseCard>
          <QuestionMarkedResponseHeader>
            <QuestionMarkedCorrectToggleField control={form.control} name="correct" />
            <QuestionMarkedPointsField control={form.control} name="points" maxPoints={maxPoints} />
          </QuestionMarkedResponseHeader>

          <QuestionMarkedResponseContent>
            <FormField
              name="correct"
              control={form.control}
              render={({ field: { value } }) => (
                <div className="flex flex-wrap gap-1">
                  {selectedOptions.map((opt) => (
                    <Badge key={opt.id} variant={value ? 'success' : 'destructive'}>
                      {opt.content}
                    </Badge>
                  ))}
                </div>
              )}
            />
          </QuestionMarkedResponseContent>

          <QuestionMarkedExplanationField control={form.control} name="explanation" />
        </QuestionMarkedResponseCard>
        <QuestionMarkedFormActions onClose={onClose} />
      </form>
    </Form>
  );
}
